<template>
  <v-dialog
    content-class="payment-action-dialog-change-tariff"
    :value="dialogs.changeTariff"
    width="474"
    :transition="false"
    @click:outside="$store.dispatch('plans/closeDialog', 'changeTariff')"
    @keydown.esc="$store.dispatch('plans/closeDialog', 'changeTariff')"
  >
    <v-card class="dialogs-card">
      <v-container class="px-8 pt-7 pb-2 payment-action-dialog-change-tariff-container">
        <v-card-text class="pa-0 payment-action-dialog-change-tariff-title">
          {{ $tc('dialogs.payment.ChangePlanFewTimes.title', isCountPlanUnpaidChanges, {count: isCountPlanUnpaidChanges}) }}
        </v-card-text>
        <v-btn
          icon
          width="fit-content"
          height="fit-content"
          class="payment-action-dialog-change-tariff-close-button"
          @click="$store.dispatch('plans/closeDialog', 'changeTariff')"
        >
          <icon name="cross20" />
        </v-btn>
      </v-container>
      <v-container class="ma-0 px-8 restriction-change-tariff-payments-container">
        <span class="restriction-change-tariff-payments">
         {{ $t('dialogs.payment.ChangePlanFewTimes.text') }}
        </span>
      </v-container>
      <v-card-actions class="px-8 pt-4 pb-7 d-flex">
        <v-btn
          class="change-tariff-payment-button"
          color="primary"
          height="36"
          @click="handleButtonClick"
        >
          <span class="change-tariff-payment-button-text">
            {{ $t('common.changePlan') }}
          </span>
        </v-btn>
        <v-btn
          outlined
          color="primary"
          class="ml-3 cancellation-action-restriction-change-tariff-payments"
          @click="$store.dispatch('plans/closeDialog', 'changeTariff')"
        >
          <span class="restriction-change-tariff-payments-cancel">
            {{ $t('common.cancel') }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import PaymentMixin from '@/mixins/payment'
import Icon from '@/assets/icons/Icon.vue'
export default {
  name: 'PaymentChangeTariffDialog',
  components: {
    Icon,
  },
  mixins: [PaymentMixin],
  props:{
    pay: {
      type: Function,
      required: true
    },
  },
  computed: {
    ...mapGetters({
      dialogs: 'plans/dialogs',
      balance: 'plans/balance'
    }),
    isCountPlanUnpaidChanges () {
      const count = this.balance.new.countPlanUnpaidChanges
      return count <= 2 ? 3 - count : count
    }
  },
  methods: {
    handleButtonClick () {
      this.pay()
      this.$store.dispatch('plans/closeDialog', 'changeTariff')
    }
  }
}
</script>
<style lang="scss">
.restriction-change-tariff-payments-cancel {
  padding: 12px 20px;
  font-family: Roboto,serif;
  color: #B547E9;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.payment-action-dialog-change-tariff {
  border-radius: 24px;
}

.payment-action-dialog-change-tariff-container {
  display: flex;
  align-items: center;
  gap: 16px;
}

.change-tariff-payment-button {
  border-radius: 50px;
  box-shadow: none;
}

.change-tariff-payment-button-text {
  font-family: Roboto,serif;
  padding: 12px 20px;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.restriction-change-tariff-payments-container {
  padding: 4px 0;
}

.restriction-change-tariff-payments {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: var(--v-text-secondary-base);
}
.cancellation-action-restriction-change-tariff-payments {
  color: #FFFFFF;
  border: 1px solid #B547E9;
  border-radius: 50px;
  box-shadow: none;
}

.payment-action-dialog-change-tariff-title {
  color: var(--v-text-primary-base);
  font-family: Roboto, serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: normal;
}

.payment-action-dialog-change-tariff-close-button {
  fill: var(--v-old-icon-button-outline-secondary-foreground-default-base);
  right: 8px;
  padding: 5px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 5px;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  padding: 12px;
  background: var(--v-background-light-green-base);
  border-radius: 50%;
}
</style>
